import { SignIn } from '@clerk/clerk-react'

export default function Login() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        background: '#f5f5f5'
      }}
    >
      <SignIn />
    </div>
  )
}
